import { render, staticRenderFns } from "./smsOrg.vue?vue&type=template&id=5a1825a3&"
import script from "./smsOrg.vue?vue&type=script&lang=js&"
export * from "./smsOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports